import React, { useState, useEffect } from 'react';
import { useSearchParams, useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import guestTranslations from '@/i18n/guestTranslations';

const TaxCalculation = () => {
  const { apartment } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const lang = params.get('lang') || 'en';
  const regId = params.get('registration_id');
  const t = guestTranslations[lang] || guestTranslations.en;
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!regId) return;
    const API = process.env.REACT_APP_BACKEND_URL || '';
    fetch(`${API}/api/guest/registration/${regId}`)
      .then(r => r.json()).then(setData);
  }, [regId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!data) return <div className="min-h-screen flex items-center justify-center bg-white"><p>Loading...</p></div>;

  const taxRate = data.tax_rate ?? 3.25;
  const commission = data.commission ?? ((data.tax_amount * 0.03) + 0.30);
  const totalAmount = data.total_amount ?? (data.tax_amount + commission);

  return (
    <div className="min-h-screen bg-white" data-testid="tax-page">
      <meta name="robots" content="noindex, nofollow" />
      <div className="bg-[#65c3ba] text-white py-6 px-4">
        <div className="max-w-xl mx-auto">
          <h1 className="text-2xl font-bold" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>{t.taxTitle}</h1>
        </div>
      </div>
      <div className="max-w-xl mx-auto px-4 py-8">
        <div className="bg-[#F7F9F9] border border-[#E2E8F0] rounded-sm p-6 space-y-4 mb-8">
          <div className="flex justify-between text-[#0A1312]">
            <span>{t.nights}</span>
            <span className="font-bold">{data.nights}</span>
          </div>
          <div className="flex justify-between text-[#0A1312]">
            <span>{t.taxableGuests}</span>
            <span className="font-bold">{data.taxable_guests}</span>
          </div>
          <div className="flex justify-between text-[#0A1312]">
            <span>{t.taxRate}</span>
            <span className="font-bold">CHF {taxRate.toFixed(2)}</span>
          </div>
          <div className="border-t border-[#E2E8F0] pt-4 flex justify-between text-[#0A1312]">
            <span className="font-semibold">{t.totalTax}</span>
            <span className="font-bold">CHF {data.tax_amount.toFixed(2)}</span>
          </div>
          <p className="text-xs text-[#0A1312]/60">
            ({data.taxable_guests} × {data.nights} × CHF {taxRate.toFixed(2)} = CHF {data.tax_amount.toFixed(2)})
          </p>
          <div className="flex justify-between text-[#0A1312]">
            <span className="text-sm">{t.commission}</span>
            <span className="text-sm font-medium">CHF {commission.toFixed(2)}</span>
          </div>
          <div className="border-t-2 border-[#65c3ba] pt-4 flex justify-between text-[#0A1312]">
            <span className="text-lg font-bold">{t.totalPayment}</span>
            <span className="text-2xl font-bold text-[#65c3ba]">CHF {totalAmount.toFixed(2)}</span>
          </div>
        </div>

        <p className="text-sm text-[#0A1312] mb-8 leading-relaxed">{t.taxNote}</p>

        <Button data-testid="proceed-payment"
          onClick={() => navigate(`/${apartment}/payment?registration_id=${regId}&lang=${lang}`)}
          className="w-full bg-[#65c3ba] text-white hover:bg-[#3e716c] py-6 text-lg rounded-sm">
          {t.proceedPayment}
        </Button>
      </div>
    </div>
  );
};

export default TaxCalculation;
